module.exports = __webpack_public_path__ + "static/media/he-IL.9de04d88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/he-IL.png
// module id = 945
// module chunks = 0